import styled from "styled-components";

export const Icon = styled.img`
  height: 60px;
  width: 60px;
  margin: auto 0.2rem;
`;

export const DayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FahrenheitWrapper = styled.div`
  color: ${({ theme }) => theme.default.color.secondary};
`;

export const CelsiusWrapper = styled.div`
  color: ${({ theme }) => theme.default.color.primary};
`;
